import { Alert, AlertDescription } from '@/components/_ui/Alert'
import T from '@/components/Helpers/Translate'
import React from 'react'

export const DesktopCountrySelectorHeader = () => (
  <div className="flex items-center justify-between">
    <span className="text-primary">
      <T>select_country</T>
    </span>
    <Alert className="w-fit py-2" variant="info">
      <AlertDescription>
        <p>
          <T>changing_country</T>
        </p>
      </AlertDescription>
    </Alert>
  </div>
)
